import { BaseApiService } from '../../../api/base';
import type { UserOnboardingState } from '../types/onboarding';

class OnboardingApiService extends BaseApiService {
  async getOnboardingStatus(): Promise<UserOnboardingState> {
    return this.get<UserOnboardingState>('onboarding/state');
  }
}

export const onboardingApiService = new OnboardingApiService();
